// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import VuiBox from "components/VuiBox";

import PageLayout from "examples/LayoutContainers/PageLayout";

import colors from "assets/theme/base/colors";

import tripleLinearGradient from "assets/theme/functions/tripleLinearGradient";
import { LOCAL_STORAGE } from "utils/constant";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";

function CoverLayout({
  color,
  header,
  title,
  description,
  motto,
  premotto,
  image,
  top,
  cardContent,
  children,
}) {
  const { gradients } = colors;
  const history = useHistory();

  useEffect(() => {
    if (localStorage.getItem(LOCAL_STORAGE.USER_TOKEN)) history.push("/dashboard");
  }, []);
  return (
    <PageLayout
      background={tripleLinearGradient(
        gradients.cover.main,
        gradients.cover.state,
        gradients.cover.stateSecondary,
        gradients.cover.angle
      )}
    >
      <VuiBox
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          alignItems: "center",
          // maxWidth: "1044px",
          minHeight: "100vh",
          margin: "0 auto",
        }}
      >
        <VuiBox>
          <VuiBox ml="auto !important">{children}</VuiBox>
        </VuiBox>
      </VuiBox>
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 20,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
